import React from "react";

export default function CollapseIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M16.3469 8.0892C16.8363 8.0892 17.2151 7.73751 17.2151 7.25955C17.2058 6.77256 16.8363 6.43891 16.3469 6.43891H15.5711L12.3387 6.61927L14.8969 4.24751L17.7506 1.46994C17.9169 1.30762 18 1.08217 18 0.847699C18 0.342687 17.6121 0 17.0949 0C16.864 0 16.6609 0.081163 16.5039 0.243489L13.6686 3.03908L11.2304 5.5371L11.4151 2.38979V1.63227C11.4151 1.15431 11.0642 0.79359 10.5839 0.79359C10.0852 0.79359 9.725 1.16333 9.725 1.63227V6.62829C9.725 7.54812 10.2699 8.0892 11.2119 8.0892H16.3469ZM7.48077 17.2426C7.97949 17.2426 8.33968 16.8819 8.33968 16.4038V11.3087C8.33968 10.3888 7.79478 9.85675 6.85276 9.85675H1.61622C1.12673 9.85675 0.748077 10.1994 0.748077 10.6864C0.757313 11.1644 1.12673 11.498 1.61622 11.498H2.49359L5.72602 11.3177L3.16779 13.6894L0.258594 16.5302C0.0923553 16.6924 0 16.9179 0 17.1524C0 17.6574 0.387892 18 0.914317 18C1.13597 18 1.34839 17.9189 1.50539 17.7565L4.39611 14.9069L6.83429 12.4089L6.64958 15.5472V16.4038C6.64958 16.8908 7.00053 17.2426 7.48077 17.2426Z"
        fill="white"
      />
    </svg>
  );
}
